import Tabla from "./tabla";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { withNotificationContext } from "js/notification-context";

export default withRouter(withApollo(withNotificationContext(Tabla)));
